export default __webpack_public_path__ + "static/media/askqsblog.dfa7131d.svg";